import { render, staticRenderFns } from "./IcoFolderPlusBadge.vue?vue&type=template&id=f4ad0b5e"
import script from "./IcoFolderPlusBadge.vue?vue&type=script&lang=js"
export * from "./IcoFolderPlusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports